<template>
  <b-card
    v-if="transaction"
    img-alt="Profile Cover Photo"
    img-top
    class="card-profile"
  >  <!--  style=" border-style: solid; border-width: 2px; border-color: #ea5355; -moz-box-shadow: 0px 10px 40px #ea5355; -webkit-box-shadow: 0px 10px 40px #ea5355;" -->
    <!----<div class="profile-image-wrapper">
        <div class="profile-image p-0">
          <b-avatar
            size="110"
            variant="danger"
            style=" border-style: danger; border-width: 5px; border-color: #ea5355;"
          />
        </div>
      </div> --->
    <h3>{{ transaction.subattending.transaction.subcustomer.name }}</h3>
    <h6 class="text-muted">
      <feather-icon icon="PhoneIcon" /> {{ transaction.subattending.transaction.subcustomer.checkout_phone }} <feather-icon icon="FolderIcon" /> {{ transaction.subattending.transaction.subcustomer.checkout_cpf_cnpj }}  <feather-icon icon="MailIcon" /> {{ transaction.subattending.transaction.subcustomer.checkout_email }}
    </h6>

    <b-badge
      class="profile-badge"
      variant="light-primary"
    >
      {{ transaction.subattending.transaction.payment.name }}
    </b-badge>

    <b-badge
      class="profile-badge"
      variant="light-primary"
    >
      {{ transaction.subattending.transaction.status.name }}
    </b-badge>

    <b-badge
      class="profile-badge"
      variant="light-primary"
    >
      {{ transaction.subattending.transaction.start_date }}
    </b-badge>

    <hr class="mb-2">

    <div>
      <h5 class="mb-0">
        <app-collapse>
          <app-collapse-item title="Produtos">
            <li v-for="item in transaction.subattending.transaction.product">
              <a
                :href=" store.url + item.link"
                target="_blank"
              >{{ item.name }}</a>
            </li>
          </app-collapse-item>
        </app-collapse>
      </h5>
    </div>

    <!--- store.url +-->
    <hr class="mb-2">
    <!-- follower projects rank -->
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h6 class="text-muted font-weight-bolder">
          Total
        </h6>
        <h3 class="mb-0">
          R$ {{ parseFloat(transaction.subattending.transaction.amount).toFixed(2) }}
        </h3>
      </div>
      <div>
        <h6 class="text-muted font-weight-bolder">
          Cupom utilizado
        </h6>
        <h3 class="mb-0">
          {{ transaction.subattending.transaction.coupon }}
        </h3>
      </div>
      <!----<div>
            <b-button
            variant="outline-dark"
            block
            >
                Pular
            </b-button>
        </div>--->
    </div>
    <!--/ follower projects rank -->

    <hr class="mb-2">
    <b-row>
      <b-col md="8">
        <b-button
          block
          variant="success"
          @click="contact(transaction.subattending.transaction.subcustomer.checkout_phone)"
        >
          Contatar
        </b-button>
      </b-col>
      <!----<b-col md="4">
          <b-button
            v-b-modal.modal-select2
            variant="warning"
            class="btn-icon"
          >
            <feather-icon icon="CalendarIcon" />
          </b-button>
        </b-col>---->
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BAvatar, BBadge, BButton, BRow, BCol,
} from 'bootstrap-vue'
import { getUserData } from '@/auth/utils'
import attending from '@/router/routes/attending'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import { getAttending, contacted, getMessage } from '../../../functions/basics/attending'
import schedule from '../../schedule/editSchedule.vue'
import './effects'

export default {
  emits: ['changeCount'],
  components: {
    BCard,
    BBadge,
    BAvatar,
    BButton,
    AppCollapseItem,
    AppCollapse,
    schedule,
    BRow,
    BCol,
  },
  props: {
    transaction: Object,
    app: Boolean,
    uuid: String,
    status: Object,
    store: Object,
    avatar: String,
    period: String,
  },
  methods: {
    async saveTransactionCache() {
      if (localStorage.getItem('transactions')?.length) {
        console.log('Entrou no save transactin')
        let newData = null
        var newTransaction = null
        const transactions = await JSON.parse(localStorage.getItem('transactions'))
        if ([transactions].length < 9) {
          console.log('entrou no < 9')
          console.log('transction: ', transactions)
          newTransaction = this.transaction.subattending.transaction
          newTransaction.subattending_id = this.transaction.subattending.id
          newData = [transactions].unshift(newTransaction)
        } else {
          console.log('entrou no > 9')
          newTransaction = this.transaction.subattending.transaction
          newTransaction.subattending_id = this.transaction.subattending.id
          newData = [newTransaction, transactions].pop()
        }
        localStorage.setItem('transactions', JSON.stringify(newData))
      } else {
        console.log('não existe')
        newTransaction = this.transaction.subattending.transaction
        newTransaction.subattending_id = this.transaction.subattending.id
        localStorage.setItem('transactions', JSON.stringify([newTransaction]))
      }
    },
    async sendMessage(phone) {
      const data = await getUserData()

      const url = (this.app) ? 'https://api.whatsapp.com/send?phone=' : 'https://web.whatsapp.com/send?phone='

      const message = await getMessage(data.mc_access_token, this.transaction.subattending.transaction.id, this.status.id)

      window.open(encodeURI(`${url}55${phone}&text=${message}`), '_blank')
    },
    updateTransactionsCache() {
      const transactions = JSON.parse(localStorage.getItem('transactions'))
      this.transactionsCache = [...transactions]
      console.log(this.transactionsCache)
    },
    async contact(phone) {
      const data = await getUserData()
      this.sendMessage(phone)
      // this.saveTransactionCache()
      // this.updateTransactionsCache()
      const respContacted = await contacted(data.mc_access_token, this.transaction.subattending.id)

      if (respContacted.status === 200) {
        const transaction = await getAttending(data.mc_access_token, this.uuid, this.status.id, this.period).catch(error => {
          this.transaction = null
          this.$emit('changeCount', null)
        })

        if (transaction.subattending) {
          this.transaction = transaction
          this.$emit('changeCount', transaction)
        } else {
          this.transaction = null
          this.$emit('changeCount', null)
        }
      }
    },
  },
}
</script>

<style>

</style>
